import ReactDOM from 'react-dom/client'
import App from './App.jsx'

// 🔹 Estilos — el orden importa: primero Bootstrap, después el Design System.
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import '@fortawesome/fontawesome-free/css/all.min.css'
// El shell del Design System, compilado desde su Sass (src/styles/ds/, que
// se trae con `npm run ds:sync`). Es la misma fuente que usan las demás apps.
import './styles/app.scss'
// Puente: traduce los nombres viejos de Tickets a los tokens del DS. Va último.
import './styles/gm-bridge.css'

import { AppProvider } from './context/AppContext'

// 🔹 Strict mode
import { StrictMode } from 'react'

/**
 * Punto de entrada principal de la aplicación React.
 * * Este archivo se encarga de:
 * 1. Inicializar el nodo raíz del DOM mediante `ReactDOM.createRoot`.
 * 2. Envolver la aplicación en `StrictMode` para detectar problemas potenciales durante el desarrollo.
 * 3. Inyectar el `AppProvider` para gestionar el estado global y el contexto de Supabase/Usuario.
 * 4. Cargar los recursos globales (Bootstrap, FontAwesome y estilos personalizados).
 */
ReactDOM.createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </StrictMode>
)

// 🔹 Service Worker para Web Push (notificaciones del navegador).
// Se registra tras la carga para no competir con el arranque de la app.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch((err) =>
        console.warn('No se pudo registrar el Service Worker:', err)
      )
  })
}
